import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaObservacao = (): TabelaColuna => ({
  Chave: 'observacao',
  RenderizarCabecalho: () => <div style={{ width: 150 }}>Observação</div>
})
